import { localStorage } from 'dibs-browser-storage';
import { trackEvent } from 'dibs-tracking';
import SV from 'server-vars';

const LINK_CLICK_TRACKING_ACTION = 'general trade modal link clicked';
const TRACKING_CATEGORY = 'trade onboarding';
const VIEW_COUNT_LOCAL_STORAGE_KEY = 'TRADE_GENERAL_ONBOARDING_MODAL_VIEW_COUNT';

const getViewCount = () => localStorage.getItem(VIEW_COUNT_LOCAL_STORAGE_KEY) || 0;

export function hasSeenTradeGeneralOnboarding() {
    return getViewCount() > 0;
}

export function logPrimaryCtaClicked() {
    trackEvent({
        action: LINK_CLICK_TRACKING_ACTION,
        category: TRACKING_CATEGORY,
        label: 'Continue Shopping',
    });
}

export function logPromotedLinkClicked({ cta } = {}) {
    trackEvent({
        action: LINK_CLICK_TRACKING_ACTION,
        category: TRACKING_CATEGORY,
        label: cta || 'cta unspecified',
    });
}

export function logTradeGeneralOnboardingView() {
    localStorage.setItem(VIEW_COUNT_LOCAL_STORAGE_KEY, getViewCount() + 1);
    trackEvent({
        action: 'general trade modal displayed',
        category: TRACKING_CATEGORY,
        label: 'none',
    });
}

export function isMobile() {
    return SV.get('settings.isMobile') || false;
}

export function isUserTypeTrade() {
    return SV.get('settings.isUserTypeTrade') || false;
}
